import { css, space } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3;
var Tag = {
  styles: {
    base: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      border-radius: 30px;\n      text-transform: uppercase;\n    "])))
  },
  Content: {
    styles: {
      base: function base(props) {
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        padding: 0 ", "em;\n      "])), space(3)(props));
      }
    }
  },
  Close: {
    styles: {
      base: function base(props) {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        border-radius: 30px;\n\n        &:focus {\n          outline: none;\n        }\n      "])));
      }
    }
  }
};

export default Tag;
